import { Box, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import useConcept from '../../hooks/useConcept';
import { Concept } from '../../models/GQL_API';

const ConceptSelector: React.FC = () => {
  const conceptsListing = useSelector((state: any) => state.concepts.listing);
  const conceptsSelected = useSelector((state: any) => state.concepts.selected);
  const { conceptsChangeSelected } = useConcept('concepts', 'concept');

  const handleConceptClick = (conceptId: string) => {
    conceptsChangeSelected(conceptId);
  };

  if (!conceptsListing || conceptsListing.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        flexWrap: 'wrap',
        maxWidth: '100%',
      }}
    >
      {conceptsListing
        .sort((a: Concept, b: Concept) => (a.precedence || 0) - (b.precedence || 0))
        .map((concept: Concept, index: number) => {
          const isSelected = conceptsSelected === concept.id;
          return (
            <Button
              key={concept.id}
              onClick={() => handleConceptClick(concept.id)}
              sx={{
                minWidth: 'auto',
                px: 2,
                py: 1,
                textTransform: 'none',
                borderRadius: 0,
                border: '1px solid',
                borderColor: 'divider',
                borderLeft: index === 0 ? '1px solid' : 'none',
                backgroundColor: isSelected ? 'primary.main' : 'transparent',
                color: isSelected ? 'common.white' : 'text.primary',
                '&:hover': {
                  backgroundColor: isSelected ? 'primary.dark' : 'action.hover',
                },
                fontSize: '14px',
                fontWeight: isSelected ? 600 : 400,
              }}
            >
              <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                {concept.name}
              </Typography>
            </Button>
          );
        })}
    </Box>
  );
};

export default ConceptSelector;

